<form [formGroup]="form" (ngSubmit)="submit()">
  <div #titleElement mat-dialog-title class="p-2" i18n>Beneficiary</div>
  <div mat-dialog-content class="px-4 pb-0">
    <div
      class="ft-observe-interseting"
      (ftObserveIntersecting)="
        appService.setOverlapped($event, titleElement)
      "></div>
    <div class="d-flex flex-column gap-2">
      <mat-form-field appearance="fill" class="w-100">
        <mat-label i18n>Name</mat-label>
        <input
          type="text"
          matInput
          formControlName="description"
          maxlength="200" />
        @if (
          form.get('description')?.invalid
        ) {
          <mat-error>
            {{ appService.getErrorMessage(form.get('description')) }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label i18n>Email</mat-label>
        <input type="email" matInput formControlName="email" maxlength="200" />
        @if (form.get('email')?.invalid) {
          <mat-error>
            {{ appService.getErrorMessage(form.get('email')) }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label i18n>Status</mat-label>
        <mat-select formControlName="statusId">
          @for (status of status(); track status.id) {
            <mat-option [value]="status.id">
              {{ status.description }}
            </mat-option>
          }
        </mat-select>
        @if (form.get('statusId')?.invalid) {
          <mat-error>
            {{ appService.getErrorMessage(form.get('statusId')) }}
          </mat-error>
        }
      </mat-form-field>
    </div>
    <div
      class="ft-observe-interseting"
      (ftObserveIntersecting)="
        appService.setOverlapped($event, actionsElement)
      "></div>
  </div>
  <div #actionsElement mat-dialog-actions class="justify-content-center">
    <button
      type="button"
      mat-stroked-button
      [disabled]="mutations.submitting()"
      mat-dialog-close
      i18n>
      Cancel
    </button>
    <button
      type="submit"
      mat-flat-button
      color="primary"
      [disabled]="mutations.submitting()">
      @if (!mutations.submitting()) {
        <span i18n>Submit</span>
      } @else {
        <ng-container *ngTemplateOutlet="submittingTemplate"></ng-container>
      }
    </button>
  </div>
</form>
<ng-template #submittingTemplate>
  <div class="text-center">
    <ft-progress class="ft-progress--2"></ft-progress>
  </div>
</ng-template>
